import { Component } from '@angular/core';
import { CartImportDialogService } from '../cart-import/cart-import-dialog.service';
import { ImportMode } from '../../model/import-export-enum.model';
import { CUSTOM_LAUNCH_CALLER } from '../../../launch-caller/launch-caller-enum.model';
import { NgbDropdownButtonItem, NgbDropdownItem } from '@ng-bootstrap/ng-bootstrap';
import { IconComponent } from '@spartacus/storefront';
import { TranslatePipe } from '@spartacus/core';

@Component({
    selector: 'app-cart-import-microcat-action',
    templateUrl: './cart-import-microcat-action.component.html',
    imports: [NgbDropdownButtonItem, NgbDropdownItem, IconComponent, TranslatePipe]
})
export class CartImportMicrocatActionComponent {

  private modalRef: any;

  constructor(private cartImportDialogService: CartImportDialogService) {
  }

  displayImportDialog(): void {
    this.cartImportDialogService.openDialogAndSubscribe(CUSTOM_LAUNCH_CALLER.CART_IMPORT, undefined, ImportMode.MICROCAT);
  }

}
